import { render, staticRenderFns } from "./SourcePicker.vue?vue&type=template&id=4379ecfe&scoped=true&"
import script from "./SourcePicker.vue?vue&type=script&lang=js&"
export * from "./SourcePicker.vue?vue&type=script&lang=js&"
import style0 from "./SourcePicker.vue?vue&type=style&index=0&id=4379ecfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379ecfe",
  null
  
)

export default component.exports